"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getLinkQueryString = function getLinkQueryString(link, name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var search = link.substr(link.indexOf('?'));
  var r = search.substr(1).match(reg);
  if (r !== null) return unescape(r[2]);
  return null;
};

var getQueryString = function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r !== null) return unescape(r[2]);
  return getLinkQueryString(window.location.href, name);
};

var replaceUrl = function replaceUrl(url, arg, val) {
  var pattern = arg + '=([^&]*)';
  var replaceText = arg + '=' + val;
  return url.match(pattern) ? url.replace(eval('/(' + arg + '=)([^&]*)/gi'), replaceText) : url.match('[\?]') ? url + '&' + replaceText : url + '?' + replaceText;
};

var urlQueryRemove = function urlQueryRemove(name) {
  var loca = window.location;
  var baseUrl = loca.origin + loca.pathname + '?';
  var query = loca.search.substr(1);

  if (query.includes(name)) {
    var obj = {};
    var arr = query.split('&');

    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split('=');
      obj[arr[i][0]] = arr[i][1];
    }

    delete obj[name];
    var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&');
    return url;
  } else {
    return window.location.href;
  }
};

var urlQueryJoin = function urlQueryJoin(url, key, value) {
  var returnUrl = '';

  if (!url.includes('?')) {
    returnUrl += url + '?' + key + '=' + value;
  } else {
    if (!url.includes('?' + key + '=') && !url.includes('&' + key + '=')) {
      returnUrl += url + '&' + key + '=' + value;
    } else {
      var isDone = false;
      var startIndex = 0;
      var endIndex = url.length - 1;
      var parm = '?' + key + '=';

      for (var i = 0; i < url.length; i++) {
        if (url.substr(i, parm.length) == parm) {
          startIndex = i + parm.length;

          for (var j = startIndex; j < url.length; j++) {
            if (url[j] == '&') {
              endIndex = j;
              break;
            } else if (j == url.length - 1) {
              endIndex = url.length;
            }
          }

          isDone = true;
          break;
        }
      }

      if (!isDone) {
        parm = '&' + key + '=';

        for (var i = 0; i < url.length; i++) {
          if (url.substr(i, parm.length) == parm) {
            startIndex = i + parm.length;

            for (var j = startIndex; j < url.length; j++) {
              if (url[j] == '&') {
                endIndex = j;
                break;
              } else if (j == url.length - 1) {
                endIndex = url.length;
              }
            }

            break;
          }
        }
      }

      var parmKeyValue = parm + url.substring(startIndex, endIndex);
      returnUrl = url.replace(parmKeyValue, parm + value);
    }
  }

  return returnUrl;
};

var notAllowValue = [undefined, null, ''];

var urlQueryObject = function urlQueryObject(url) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var queryStr = Object.keys(query).reduce(function (ary, key) {
    if (!notAllowValue.includes(query[key])) {
      ary.push(encodeURIComponent(key) + '=' + encodeURIComponent(query[key]));
    }

    return ary;
  }, []).join('&');
  var res = url += queryStr ? "?".concat(queryStr) : '';
  return res;
};

var createCloudPageUrl = function createCloudPageUrl(url) {
  var isDev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var arr = url.split('?');
  arr[0] = encodeURIComponent(arr[0]);
  arr[1] = arr[1].replaceAll('=', ':');
  arr[1] = arr[1].replaceAll('&', ',');
  var res = 'goUrl=' + arr.join('&urlParams=');
  console.log(res);
  var host = !isDev ? 'https://release-9ghc051ka222b427-1304718613.tcloudbaseapp.com/receiver/index.html?' : 'https://cloud1-3gwlkoap98aa5ab0-1305296267.tcloudbaseapp.com/receiver/index.html?';
  return host + res;
};

var getUrlRelativePath = function getUrlRelativePath() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var arrUrl = url.split('//');
  var start = arrUrl[1].indexOf('/');
  var relUrl = arrUrl[1].substring(start);

  if (relUrl.includes('?')) {
    relUrl = relUrl.split('?')[0];
  }

  return relUrl;
};

var urlParamsDel = function urlParamsDel(names) {
  try {
    if (typeof names === 'string') {
      names = [names];
    }

    var loca = window.location;
    var obj = {};
    var arr = loca.search.substr(1).split('&');

    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split('=');
      obj[arr[i][0]] = arr[i][1];
    }

    for (var i = 0; i < names.length; i++) {
      delete obj[names[i]];
    }

    var url = loca.origin + loca.pathname + '?' + JSON.stringify(obj).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&');
    return url;
  } catch (error) {
    return location.href;
  }
};

var locationSearchToObj = function locationSearchToObj() {
  var params = {};
  window.location.search.slice(1).split('&').forEach(function (item, i) {
    var arr = item.split('=');
    params[arr[0]] = arr[1];
  });
  return params;
};

var _default = {
  locationSearchToObj: locationSearchToObj,
  urlParamsDel: urlParamsDel,
  getUrlRelativePath: getUrlRelativePath,
  createCloudPageUrl: createCloudPageUrl,
  urlQueryObject: urlQueryObject,
  urlQueryRemove: urlQueryRemove,
  urlQueryJoin: urlQueryJoin,
  replaceUrl: replaceUrl,
  getQueryString: getQueryString,
  getLinkQueryString: getLinkQueryString
};
exports["default"] = _default;